document.addEventListener('DOMContentLoaded', () => {
	// Find all compare slider blocks on the page
	const sliders = document.querySelectorAll('.block-card-compare-slider');
	//console.log('Found sliders:', sliders.length); // For debugging: log the number of sliders found

	sliders.forEach((slider) => {
		// Get the range input, the 'after' image container, and the handle element within this slider
		const range = slider.querySelector('.block-card-compare-slider__input');
		const after = slider.querySelector(
			'.block-card-compare-slider__image-container--after'
		);
		const handle = slider.querySelector(
			'.block-card-compare-slider__handle'
		);

		// Function to update the slider UI based on the current value
		const update = (value) => {
			const percent = `${value}%`;
			after.style.width = percent; // Set the width of the 'after' image
			handle.style.left = percent; // Move the handle to match the slider position
		};

		// Set initial slider position on page load
		update(range.value);

		// Update the slider UI as the user moves the range input
		range.addEventListener('input', (e) => update(e.target.value));
		// Also update on change (for accessibility and keyboard interaction)
		range.addEventListener('change', (e) => update(e.target.value));
	});
});
